module.exports = "/virtual-football-league/img/amblems/left/logos/Bayern.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Bayern.png
// module id = 2056
// module chunks = 4